import { createBrowserClient } from '@supabase/ssr'
import type { Database } from './types'

export function createClient() {
  const cookieName = process.env.NEXT_PUBLIC_SUPABASE_COOKIE_NAME
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    cookieName ? { cookieOptions: { name: cookieName } } : {}
  )
}
